<template>
  <div>
    <v-data-table dense
                  :loading="loading"
                  :headers="headers"
                  :items="sessions"
                  :items-per-page="100">

      <template v-slot:item.id="{item: session}">
        <router-link :to="{name: `${$root.routePrefix}.device_session.show`, params: {sessionID: session.id}}">
          {{ session.id }}
        </router-link>
      </template>

      <template v-slot:item.live_mode="{item: session}">
        {{ session.live_mode ? 'Yes' : 'No' }}
      </template>

      <template v-slot:item.started_at="{item: session}">
        {{ session.started_at | datetime('YYYY-MM-DD h:mm a') }}
      </template>

      <template v-slot:item.duration="{item: session}">
        {{ session.duration ? session.duration_for_humans : '' }}
      </template>

      <template v-slot:item.crm_related_id="{item: session}">
        <div v-if="session.crm_object_id && session.crm_related_id">
          <a :href="`https://allergannewmaorg.lightning.force.com/lightning/r/${session.crm_related_object}/${session.crm_related_id}/view`"
             target="_blank">
            Connected
          </a>
        </div>
        <v-btn v-else
               @click.prevent="editSession(session)"
               x-small>
          Connect
        </v-btn>
      </template>

    </v-data-table>

    <allergan-device-session-dialog v-if="session"
                                    :dialog="dialog"
                                    :session="session"
                                    @close="closeDialog"
                                    @updated="updated">
    </allergan-device-session-dialog>
  </div>
</template>
<script>
import AllerganDeviceSessionDialog from "./AllerganDeviceSessionDialog";

export default {
  components: {AllerganDeviceSessionDialog},
  props: {
    sessions: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data() {
    return {
      dialog: false,
      session: null,
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Mobile Locker Session',
          value: 'id',
          cellClass: 'text-nowrap',
        },
        {
          text: 'Moxie Call Interaction',
          value: 'crm_related_id',
          cellClass: 'text-nowrap',
        },
        {
          text: 'Date',
          value: 'started_at',
          cellClass: 'text-nowrap',
        },
        {
          text: 'Presentation',
          value: 'presentation.name',
        },
        {
          text: 'Duration',
          value: 'duration',
          cellClass: 'text-nowrap',
        },
      ];
    }
  },
  methods: {
    editSession(session) {
      this.session = session;
      this.dialog = true;
    },
    updated() {
      this.$emit('updated');
      this.closeDialog(); // MLD-3939
    },
    closeDialog() {
      this.session = null;
      this.dialog = false;
    }
  }
}
</script>
